import { Quote, Sparkles } from "lucide-react";
import Reveal from "@/components/Reveal";

const testimonials = [
  {
    id: "camila",
    initials: "CR",
    name: "Camila R.",
    context: "Former Language School Student, Brazil",
    quote: "When my language school closed, I was worried about losing momentum. Tammam’s complimentary diagnostic call and pay-as-you-go classes gave me immediate direction without locking me into a long contract. I gained more real speaking confidence in two weeks than in three months of traditional textbook classes.",
  },
  {
    id: "kenji",
    initials: "KM",
    name: "Kenji M.",
    context: "International Student, Japan",
    quote: "In regular ESL classes, you learn grammar for tests, but you still feel hesitant talking to Canadians. Tammam taught me how people actually speak in daily life and gave me the exact confidence needed for job interviews. The 9-Class Private Bundle made a huge difference.",
  },
  {
    id: "ananya",
    initials: "AS",
    name: "Ananya S.",
    context: "PR Newcomer, India",
    quote: "As a newcomer to Canada, I had strong English knowledge, but I struggled with workplace nuance, Canadian idioms, and professional positioning. Tammam’s strategy and advertising background was a game-changer—he taught me how to communicate effectively with Canadian hiring managers.",
  },
];

const TestimonialsSection = () => (
  <section className="testimonials-section section-space" aria-labelledby="testimonials-title" data-testid="testimonials-section">
    <Reveal className="section-inner">
      <div className="testimonials-heading-row">
        <div><div className="section-kicker">REAL LEARNER PERSPECTIVES</div><h2 id="testimonials-title">Progress that sounds like real life.</h2></div>
        <p>Stories from newcomers and international students building confidence for the conversations that matter.</p>
      </div>
      <div className="testimonials-grid">
        {testimonials.map((testimonial) => (
          <article className="testimonial-card" key={testimonial.id} data-testid={`testimonial-card-${testimonial.id}`}>
            <div className="testimonial-card-top"><span className="testimonial-initials" aria-hidden="true">{testimonial.initials}</span><Quote size={21} aria-hidden="true" /></div>
            <blockquote>“{testimonial.quote}”</blockquote>
            <div className="testimonial-attribution"><strong>{testimonial.name}</strong><span>{testimonial.context}</span></div>
          </article>
        ))}
      </div>
      <p className="testimonial-note"><Sparkles size={14} aria-hidden="true" /> Learner stories are shared with permission.</p>
    </Reveal>
  </section>
);

export default TestimonialsSection;
